import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminCompanyManagement';
import * as getSettingBooth from '../../../actions/AdminSettingBooth';
import ListProductExhibition from '../../../pages/Admin/CompanyManagement/ListProductExhibition';
import withAuth from '../../../common/WithAuth';
import DetailCompanySelector from '../../../selectors/AdminCompanyManagement';
import SettingBoothSelector from '../../../selectors/AdminSettingBooth';
import { clearUpdateProductOrder, updateProductOrderRequested } from '../../../actions/ProductManagement';

const createDetailCompanySelector = DetailCompanySelector.createDetailCompanySelector();

const mapStateToProps = (state) => {
    const settingBoothData = SettingBoothSelector.createSettingSelector()(state);
    const isLoading = state.adminCompanyManagement.listProduct.isFetching
    || state.adminCompanyManagement.detailCompany.isFetching
    || state.adminCompanyManagement.detailProduct.isFetching
    || state.adminCompanyManagement.editProduct.isFetching
    || state.adminCompanyManagement.deleteProduct.isFetching
    || state.productManagement.productOrder.isFetching;

    return ({
        settingBoothData,
        locale: state.locale.lang.current,
        listProductExhibition: state.adminCompanyManagement.listProduct.data,
        page: state.adminCompanyManagement.listProduct.data && state.adminCompanyManagement.listProduct.data.page,
        totalPage: state.adminCompanyManagement.listProduct.data && state.adminCompanyManagement.listProduct.total_page,
        isFechingDelete: state.adminCompanyManagement.deleteProduct.isFetching,
        errorsDelete: state.adminCompanyManagement.deleteProduct ? state.adminCompanyManagement.deleteProduct.errors : {},
        deleteSuccess: state.adminCompanyManagement.deleteProduct.deleteSuccess,
        companyDetail: createDetailCompanySelector(state),
        editSuccess: state.adminCompanyManagement.editProduct.success,
        token: state.auth.credential.data.token,
        isLoading,
        updateOrderSuccess: state.productManagement.productOrder.success,
        updateOrderError: state.productManagement.productOrder.errors,
    });
};

const mapDispatchToProps = (dispatch) => ({
    getSettingBooth: (eventShortName) => dispatch(getSettingBooth.getSettingBoothRequested(eventShortName)),
    fetchListProduct: (companyID, params) => dispatch(Action.GetListProductExhibitionRequested({companyID, params})),
    fetchDeleteProduct: (params) => dispatch(Action.DeleteProductExhibitionRequested(params)),
    fetchClearDeleteProduct: () => dispatch(Action.ClearDeleteProductExhibition()),
    fetchGetDetailCompany: (params) => dispatch(Action.GetDetailCompanyRequested(params)),
    fetchClearGetDetailCompany: () => dispatch(Action.ClearGetDetailCompany()),
    fetchClearEditExhibition: () => dispatch(Action.ClearEditProductExhibition()),
    updateProductOrder: (companyID, objSeq) => dispatch(updateProductOrderRequested({companyID, objSeq})),
    clearUpdateProductOrder: () => dispatch(clearUpdateProductOrder()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListProductExhibition);
